import { observable } from 'mobx';

export type BugyoMasterItemResponseArgs = {
  code: string;
  name: string;
};

export type BugyoMasterItemArgs = {
  code: string;
  name: string;
};

export const convertBugyoMasterItemResponseToArgs = (response: BugyoMasterItemResponseArgs) => {
  const args: BugyoMasterItemArgs = {
    code: response.code,
    name: response.name
  };
  return args;
};

export default class BugyoMasterItem {
  @observable code: string;
  @observable name: string;

  constructor(args: BugyoMasterItemArgs) {
    this.code = args.code;
    this.name = args.name;
  }

  get label(): string {
    return this.name ? `${this.code}:${this.name}` : this.code;
  }
}
